const NS = 'ImageSelectionBlock';
const CLS = 'imageSelectionBlock';

import { fullWindowHeightMixinBlock } from '../../mixins/fullWindowHeightMixinBlock/fullWindowHeightMixinBlock';
import { compactViewMixinBlock } from '../../mixins/compactViewMixinBlock/compactViewMixinBlock';

export class ImageSelectionBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.initCompactView(this, ['.imageSelectAnswerBlock']);
		this.initFullWindowHeight(this);
	}
}

Object.assign(ImageSelectionBlock.prototype, fullWindowHeightMixinBlock);
Object.assign(ImageSelectionBlock.prototype, compactViewMixinBlock);
